import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, ICalendarItem } from '../../model/calendar-item.model'

export const ACTION_TYPES = {
  FETCH_CALENDARITEM_LIST: 'calendarItem/FETCH_CALENDARITEM_LIST',
  FETCH_CALENDARITEM: 'calendarItem/FETCH_CALENDARITEM',
  CREATE_CALENDARITEM: 'calendarItem/CREATE_CALENDARITEM',
  UPDATE_CALENDARITEM: 'calendarItem/UPDATE_CALENDARITEM',
  DELETE_CALENDARITEM: 'calendarItem/DELETE_CALENDARITEM',
  SET_BLOB: 'calendarItem/SET_BLOB',
  RESET: 'calendarItem/RESET',
}

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ICalendarItem>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
}

export type CalendarItemState = Readonly<typeof initialState>;

// Reducer

export default (state: CalendarItemState = initialState, action): CalendarItemState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CALENDARITEM_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CALENDARITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      }
    case REQUEST(ACTION_TYPES.CREATE_CALENDARITEM):
    case REQUEST(ACTION_TYPES.UPDATE_CALENDARITEM):
    case REQUEST(ACTION_TYPES.DELETE_CALENDARITEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      }
    case FAILURE(ACTION_TYPES.FETCH_CALENDARITEM_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CALENDARITEM):
    case FAILURE(ACTION_TYPES.CREATE_CALENDARITEM):
    case FAILURE(ACTION_TYPES.UPDATE_CALENDARITEM):
    case FAILURE(ACTION_TYPES.DELETE_CALENDARITEM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      }
    case SUCCESS(ACTION_TYPES.FETCH_CALENDARITEM_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      }
    case SUCCESS(ACTION_TYPES.FETCH_CALENDARITEM):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.CREATE_CALENDARITEM):
    case SUCCESS(ACTION_TYPES.UPDATE_CALENDARITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.DELETE_CALENDARITEM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      }
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      }
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
};

const apiUrl = 'api/calendar-items'
const apiSearchUrl = 'api/_search/calendar-items'

// Actions

export const getEntities: ICrudGetAllAction<ICalendarItem> = (page, size, sort, filters?: {}) => {
  let requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`
  if (filters) {
    if (filters['calendarItemTitle']) {
      requestUrl += `${requestUrl.indexOf('?') >= 0 ? '&' : '?'}calendarItemTitle.contains=${filters['calendarItemTitle']}`
    }
    if (filters['calendarItemLocation']) {
      requestUrl += `${requestUrl.indexOf('?') >= 0 ? '&' : '?'}calendarItemLocation.contains=${filters['calendarItemLocation']}`
    }
  }
  return {
    type: ACTION_TYPES.FETCH_CALENDARITEM_LIST,
    payload: axios.get<ICalendarItem>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  }
}

export const getEntity: ICrudGetAction<ICalendarItem> = id => {
  const requestUrl = `${apiUrl}/${id}`
  return {
    type: ACTION_TYPES.FETCH_CALENDARITEM,
    payload: axios.get<ICalendarItem>(requestUrl),
  }
}

export const createEntity: ICrudPutAction<ICalendarItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CALENDARITEM,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  })
  dispatch(getEntities())
  return result
}

export const updateEntity: ICrudPutAction<ICalendarItem> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CALENDARITEM,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  })
  return result
}

export const deleteEntity: ICrudDeleteAction<ICalendarItem> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CALENDARITEM,
    payload: axios.delete(requestUrl),
  })
  dispatch(getEntities())
  return result
}

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
})

export const reset = () => ({
  type: ACTION_TYPES.RESET,
})
